var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isButton_(_vm.scrId, 'AD'))?_c('sf-button',{attrs:{"onClick":_vm.releaseAction}},[_vm._v(_vm._s(_vm.getMessage_('SWCC000786')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }